<nav class="navbar navbar-expand-lg">
  <a class="navbar-brand">
    <!--<img src="assets/images/logo.png" alt=""/>-->
  </a>
  <button class="navbar-toggler" type="button">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse">
    <ul class="navbar-nav ml-auto">
      <li class="nav-item mr-4" *ngIf="isLogged">
        <span>{{serverUrl}}/{{username}}</span>
      </li>
      <li *ngIf="isLogged" class="nav-item">
        <mat-icon class="fill-primary cursor-pointer" svgIcon="exit_ico" (click)="logout()" ></mat-icon>
      </li>
    </ul>
  </div>
</nav>

